import React from "react";
// import { Modal, Table, Tooltip } from "your-ui-library"; // Replace with your actual UI components

const calculateFees = (ticketPrice) => {
  let karamaleRate = 0.02;
  if (ticketPrice >= 100 && ticketPrice <= 499) karamaleRate = 0.0225;
  else if (ticketPrice >= 500 && ticketPrice <= 999) karamaleRate = 0.02;
  else if (ticketPrice >= 1000) karamaleRate = 0.015;

  const karamaleFee = ticketPrice * karamaleRate;
  const gatewayFee = ticketPrice * 0.035 + 2.0;
  const totalFee = karamaleFee + gatewayFee;

  return {
    karamaleFee: karamaleFee.toFixed(2),
    gatewayFee: gatewayFee.toFixed(2),
    totalFee: totalFee.toFixed(2),
    karamaleRate: (karamaleRate * 100).toFixed(2),
  };
};

const BookingFeeBreakdownModal = ({
  ticketPrice,
  bookingFee,
  karamaleFee,
  karamaleRate,
  gatewayFlatFee,
  gatewayRate,
  estimatedGatewayFee,
  finalEstimatedGatewayFee,
  onClose,
}) => {
  // const { karamaleFee, gatewayFee, totalFee, karamaleRate } =
  // calculateFees(ticketPrice);
  // if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="refund-modal text-12">
        <p>
          <span className=" text-12">Your booking fee covers:</span>
          <ul>
            <li className=" text-12">
              Secure payment processing via our gateway
            </li>
            <li className=" text-12">
              Platform support & organizer tools via Karamale
            </li>
          </ul>
          Fees are tiered based on ticket price to keep things fair and
          transparent.
        </p>

        <table className="table table-bordered table-striped">
          <thead>
            <tr>
              <th>Component</th>
              <th>Rate</th>
              <th>Amount</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                Karamale Service Fee
                {/* <Tooltip content="Supports platform features, governance, and organizer tools" /> */}
              </td>
              <td>{(Number(karamaleRate) * 100).toFixed(2)}% </td>
              <td>R{Number(karamaleFee).toFixed(2)}</td>
            </tr>
            <tr>
              <td>
                Gateway Processing Fee
                {/* <Tooltip content="Covers secure payment processing (3.5% + R2.00)" /> */}
              </td>
              <td>
                {(Number(gatewayRate) * 100).toFixed(1)}% + R
                {Number(gatewayFlatFee).toFixed(2)}
              </td>
              <td>R{Number(finalEstimatedGatewayFee).toFixed(2)}</td>
            </tr>
            <tr>
              <td>
                <strong>Total Booking Fee</strong>
              </td>
              <td>—</td>
              <td>
                <strong>R{Number(bookingFee).toFixed(2)}</strong>
              </td>
            </tr>
          </tbody>
        </table>

        <p style={{ marginTop: "1rem" }}>
          Karamale believes in <strong>transparent pricing</strong>. Every rand
          is accounted for — no hidden charges.
        </p>
        <button
          type="button"
          className="float-right save-btn "
          onClick={onClose}
        >
          Close
        </button>
      </div>
    </div>
  );
};

export default BookingFeeBreakdownModal;
